import React, { useState, useRef } from 'react';
import { Box } from '@mui/material';
import { Modal } from 'antd';
import EventList from '../components/events/EventList';
import EventForm from '../components/events/EventForm';
import PageHeader from '../components/common/PageHeader';
import { EventNoteOutlined as EventIcon } from '@mui/icons-material';

const EventsPage = () => {
  const listRef = useRef();
  const [selectedItem, setSelectedItem] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);

  const handleEdit = (item) => {
    setSelectedItem(item);
    setIsModalVisible(true);
  };

  const handleSuccess = () => {
    setIsModalVisible(false);
    setSelectedItem(null);
    // Refresh the list after successful operation
    listRef.current?.refresh();
  };

  return (
    <Box className="premium-container">
      <PageHeader
        title="Events"
        btnText="ADD EVENT"
        titleIcon={<EventIcon />}
        subtitle="Coordinate and manage upcoming gymkhana events and competitions."
        onBtnClick={() => {
          setSelectedItem(null);
          setIsModalVisible(true);
        }}
      />

      <Box className="premium-table-card">
        <EventList ref={listRef} onEdit={handleEdit} />
      </Box>

      <Modal
        title={selectedItem ? 'Edit Event' : 'Add Event'}
        open={isModalVisible}
        onCancel={() => {
          setIsModalVisible(false);
          setSelectedItem(null);
        }}
        footer={null}
        width={800}
      >
        <EventForm
          initialValues={selectedItem}
          onSuccess={handleSuccess}
          onCancel={() => {
            setIsModalVisible(false);
            setSelectedItem(null);
          }}
        />
      </Modal>
    </Box>
  );
};

export default EventsPage;
